import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// CORE COMPONENTS
import Addon from 'core/form/parts/Addon';

// STYLES
import styles from '../select.module.scss';

// MAIN COMPONENT
const DropdownIndicator = ({
  className,
  selectProps,
  ...props
}) => (
  <Addon
    className={clsx(
      styles.dropdownIndicator,
      styles.addon,
      styles.append,
      styles[selectProps.size],
      className
    )}
    use={selectProps.menuIsOpen ? 'chevron-up' : 'chevron-down'}
    size={selectProps.size}
    {...(selectProps.append || {})}
    {...props}
  />
)

// EXPORT
export default DropdownIndicator
